import { useTranslations } from 'next-intl';
import { IProduct } from '@monofront/types';

interface IProductCompositionProps {
  product: IProduct;
}

const ProductComposition: React.FC<IProductCompositionProps> = ({
  product,
}) => {
  const tProducts = useTranslations('Products');

  const composition = product.meta.marketing?.kit_composition || '';

  if (!composition) return null;

  return (
    <>
      <h3 className="tw-lf-body-xbold-md tw-mt-5">
        {tProducts('composition')}
      </h3>
      <div
        className="tw-lf-rich-text tw-mt-2 tw-leading-normal"
        dangerouslySetInnerHTML={{
          __html: composition,
        }}
      />
    </>
  );
};

export default ProductComposition;
